import { Box } from "@chakra-ui/react";
import { RiskFactor, riskFactorColors } from "@keita/lanepatrol-sdk";
import { CraColoringLegendItem } from "./CraColoringLegendItem";
import { tRiskFactor } from "../../../../coding/utils/score-utils";

const crashTypes = Object.values(RiskFactor).reverse();

export const CraColoringScore: React.FC = () => {
  return (
    <Box>
      {crashTypes.map((crashType) => (
        <CraColoringLegendItem key={crashType} color={riskFactorColors[crashType]}>
          {tRiskFactor(crashType)}
        </CraColoringLegendItem>
      ))}
    </Box>
  );
};
